<template>
  <FormLayout>
    <div class="card shadow-lg border-0 mx-auto" style="width: 100%; background-color: white;">
      <div class="card-header bg-light" :style="computedStyle">
        <h4 class="text-center">{{ title }}</h4>
      </div>
      <div class="text-center">
        <div class="bg-secondary text-white d-flex align-items-center justify-content-center" style="height: 150px">
          <h1>Banner de evento</h1>
        </div>
      </div>
      <div class="card-body socialprofile filter-cards-view">
        <div class="card mb-4">
          <div class="card-header bg-primary text-white">
            <h5>Datos generales</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>{{ documentType }}</label>
                <input class="form-control text-uppercase" type="text" placeholder="Nro de Documento" disabled />
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3" v-if="isGeneralForm">
                <label>Complemento</label>
                <input class="form-control text-uppercase" type="text" placeholder="Complemento" disabled />
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                <label>Nacionalidad</label>
                <div class="d-flex justify-content-center">
                  <div class="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                    <div class="radio radio-primary">
                      <input type="radio" name="nationality" disabled />
                      <label class="mb-0">Nacional</label>
                    </div>
                    <div class="radio radio-primary">
                      <input type="radio" name="nationality" disabled />
                      <label class="mb-0">Extranjero</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Apellido Paterno</label>
                <input class="form-control text-uppercase" type="text" placeholder="Apellido Paterno" disabled />
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                <label>Apellido Materno</label>
                <input class="form-control text-uppercase" type="text" placeholder="Apellido Materno" disabled />
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                <label>Nombre(s)</label>
                <input class="form-control text-uppercase" type="text" placeholder="Nombre(s)" disabled />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                <label>Fecha de Nacimiento</label>
                <input class="form-control text-uppercase" type="date" placeholder="Fecha de Nacimiento" disabled />
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-4">
          <div class="card-header bg-secondary text-white">
            <h5>Sección de información</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                <label>Departamento</label>
                <input class="form-control text-uppercase" type="text" placeholder="Departamento" disabled />
              </div>
              <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
                <label>{{ institutionLabel }}</label>
                <input class="form-control text-uppercase" type="text" :placeholder="institutionPlaceholder" disabled />
              </div>
            </div>
            <div class="row">
              <template v-if="isGeneralForm">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                  <label>Ocupación</label>
                  <input class="form-control text-uppercase" type="text" placeholder="Ocupación" disabled />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                  <label>Cargo</label>
                  <input class="form-control text-uppercase" type="text" placeholder="Cargo" disabled />
                </div>
              </template>
              <template v-if="isStudentForm">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                  <label>Nivel</label>
                  <input class="form-control" type="text" placeholder="Nivel" disabled />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                  <label>Grado</label>
                  <input class="form-control text-uppercase" type="text" placeholder="Ej: 5to Secundaria, 3er Semestre" disabled />
                </div>
              </template>
              <template v-if="isTeacherForm">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                  <label>Materia</label>
                  <input class="form-control text-uppercase" type="text" placeholder="Ejemplo: Matemática, Biología, Informática..." disabled />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                  <label class="mb-2 d-block text-center">Actualmente se encuentra en ejercicio?</label>
                  <div class="form-group m-checkbox-inline mb-0 custom-radio-ml d-flex justify-content-center gap-3">
                    <div class="radio radio-primary">
                      <input type="radio" name="in_service" disabled />
                      <label class="mb-0">Sí</label>
                    </div>
                    <div class="radio radio-primary">
                      <input type="radio" name="in_service" disabled />
                      <label class="mb-0">No</label>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="mt-4">
              <p class="text-muted">Aquí irán los campos específicos que usted agregue.</p>
              <h4 class="mb-4 text-primary">Campos Específicos</h4>
            </div>
          </div>
        </div>
        <div class="card mb-4">
          <div class="card-header bg-info text-white">
            <h5>Sección de contacto</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                <label>Nro Celular</label>
                <input class="form-control text-uppercase" type="text" placeholder="Celular/Teléfono" disabled />
              </div>
              <div class="col-lg-8 col-md-6 col-sm-12 mb-3">
                <label>Correo Electrónico</label>
                <input class="form-control" type="email" placeholder="Correo Electrónico" disabled />
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn btn-success text-center" disabled>Registrar Inscripción</button>
        </div>
      </div>
    </div>
  </FormLayout>
</template>

<script setup>
import { computed } from 'vue';
import FormLayout from '../FormLayout.vue';

const props = defineProps({
  formType: {
    type: String,
    default: ''
  }
});

const isGeneralForm = computed(() => props.formType === 'general');
const isStudentForm = computed(() => props.formType === 'students');
const isTeacherForm = computed(() => props.formType === 'teachers');

const title = computed(() => {
  switch (props.formType) {
    case 'general':
      return 'Formulario Base - Población en General';
    case 'students':
      return 'Formulario Base - Solo Estudiantes';
    case 'teachers':
      return 'Formulario Base - Solo Maestros';
    default:
      return 'Formulario Base';
  }
});

const documentType = computed(() => {
  switch (props.formType) {
    case 'general':
      return 'CI';
    case 'students':
      return 'RUDE';
    case 'teachers':
      return 'RDA';
    default:
      return 'Documento';
  }
});

const institutionLabel = computed(() => {
  if (isStudentForm.value || isTeacherForm.value) {
    return 'Institución Educativa';
  } else {
    return 'Institución / Empresa u Organización';
  }
});

const institutionPlaceholder = computed(() => {
  if (isStudentForm.value) {
    return 'Institución donde estudia';
  } else if (isTeacherForm.value) {
    return 'Institución donde trabaja';
  } else {
    return 'Institución donde trabaja';
  }
});

const computedStyle = computed(() => {
  switch (props.formType) {
    case 'general':
      return 'background: linear-gradient(to right, #e0f7fa, #0288d1) height: 100px;';
    case 'students':
      return 'background: linear-gradient(to right, #f1f8e9, #558b2f) height: 100px;';
    case 'teachers':
      return 'background: linear-gradient(to right, #fff3e0, #ef6c00) height: 100px;';
    default:
      return 'background: #f0f0f0';
  }
});
</script>
